import React, { useState } from "react";
import type { Bank } from "../types";
import { BenefitsRow } from "./BenefitsRow";
import { BankPicker } from "./BankPicker";
import { BankConnectModal } from "./BankConnectModal";

interface EmptyStateProps {
  onBankConnected: (bank: Bank) => void;
  onCsvImport?: () => void;
}

export function EmptyState({ onBankConnected, onCsvImport }: EmptyStateProps) {
  const [selectedBank, setSelectedBank] = useState<Bank | null>(null);

  const handleBankSelect = (bank: Bank) => setSelectedBank(bank);
  const handleClose = () => setSelectedBank(null);
  const handleConnected = (bank: Bank) => {
    setSelectedBank(null);
    onBankConnected(bank);
  };
  const handleCsvImport = () => {
    if (onCsvImport) onCsvImport();
  };

  return (
    <>
      <div className="inline-flex items-center gap-2 mb-1.5">
        <span className="w-[18px] h-[18px] rounded-full bg-vela text-white inline-flex items-center justify-center text-[9px] font-extrabold">
          V
        </span>
        <span className="text-[11.5px] font-bold text-vela-deep">Vela intro</span>
      </div>
      <h2 className="text-lg md:text-2xl font-bold text-ink mb-1">
        Connect your first bank to get started
      </h2>
      <p className="text-[12.5px] md:text-[13.5px] text-ink3 leading-relaxed mb-6 max-w-2xl">
        Once connected, your transactions sync nightly, cryptic descriptions get cleaned into real names, invoices and payroll runs get matched, and transactions get categorized automatically. You review the exceptions.
      </p>

      <BenefitsRow />
      <BankPicker onBankSelect={handleBankSelect} onCsvImport={handleCsvImport} />

      {selectedBank && (
        <BankConnectModal
          bank={selectedBank}
          onClose={handleClose}
          onConnected={handleConnected}
        />
      )}
    </>
  );
}